import { useOutletContext, Navigate } from 'react-router-dom';
import { useSeo } from '@/lib/seo';

export default function GearPage() {
  const { config } = useOutletContext() || {};
  useSeo({
    title: 'What I Actually Use | A Guy Who Hunts',
    description: 'A running list of the gear I personally use — not a list of everything companies want to sell me.',
  });

  if (config && !config.gear_nav_enabled) {
    return <Navigate to="/" replace />;
  }

  return (
    <div>
      <section className="relative border-b border-[hsl(var(--border))] hero-radial">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <p className="kicker">Gear</p>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-2 leading-tight">
            What I actually use.
          </h1>
          <p className="mt-4 max-w-2xl text-[hsl(var(--muted-foreground))]">
            These are items I personally use — not a list of everything companies want to sell me.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 prose-editorial">
        <p>The gear list is being written entry by entry. Categories will appear here as they’re published:</p>
        <ul>
          <li>Hunting equipment</li>
          <li>Trail cameras</li>
          <li>Filming equipment</li>
          <li>Clothing</li>
          <li>Packs</li>
          <li>Optics</li>
          <li>Bow or rifle setups</li>
          <li>Editing equipment</li>
        </ul>
        <p className="text-[hsl(var(--muted-foreground))]">
          When affiliate links appear on this page, they will be clearly disclosed. Nothing recommended has to be paid
          for to earn a spot.
        </p>
      </section>
    </div>
  );
}
